import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Modal} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import FilterIcon from "@material-ui/icons/FilterList";
import Download from "@material-ui/icons/CloudDownload";
import Upload from "@material-ui/icons/CloudUpload";
import VideoPlay from "@material-ui/icons/OndemandVideoSharp";
import RubricIcon from "@material-ui/icons/CloudUpload";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import axios from 'axios';
import {ToastContainer, toast} from 'react-toastify';

const defaultToolbarSelectStyles = {
  iconButton: {
    marginRight: "24px",
    top: "50%",
    display: "inline-block",
    position: "relative",
    transform: "translateY(-50%)"
  },
  deleteIcon: {
    color: "#000"
  },
  doneAllIcon: {
    color: "#006D5B",
    marginTop:"2rem"
  }
  ,
  uploadIcon: {
    color: "#0000FF",
    marginTop:"2rem"
  },
  rubricIcon:{
    color: "#FFA500",
    marginTop:"2rem"
  }
};

const mapStateToProps = state => ({
  subject_selected: state.subject_selected,
  course_name: state.course_name,
  available_scripts: state.available_scripts
});

class CustomToolbarSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {             
        available_scripts:this.props.available_scripts,
        course_name: this.props.course_name,
        table_data:[],
        student:{name:'',
      surname:''},
        content_type:'',
        uploadDialog:false,
        modalIsOpen: false,
        rubricModalIsOpen: false,
        submission_total:0,
            submission_mark:0,
            selectedFile:null,
            assessment:{assessment_name:''},
            assessment_name:''
    };  
       this.handleChange = this.handleChange.bind(this);
       this.getAssessmentTotal = this.getAssessmentTotal.bind(this);
  }

  componentDidMount(){
    console.log('check state select custom select',this.props.selectedRows);
    let student_index = this.props.selectedRows.data[0].dataIndex;
    let student_cur = this.state.available_scripts[student_index].student;
    let content_type = this.state.available_scripts[student_index].content_type;
    //console.log('content type is: ',content_type);
    let script = this.state.available_scripts[student_index].assessment;
    // console.log('script',script.assessment_name.toLowerCase().includes('visual arts'));
    this.setState({student:student_cur,content_type:content_type, assessment:script,assessment_name:script.assessment_name });

    this.getAssessmentTotal();
  }

  getAssessmentTotal(){
    let token = localStorage.getItem('access_token');
    //console.log('getting temporal scripts');
    let cur = this;
    let selected_script = this.state.available_scripts[this.props.selectedRows.data[0].dataIndex];
    axios.get('https://admin.thinkdigitalacademy.org/api/get-assessment-total/' + selected_script.id, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(res => {
        // console.log('assessment', res.data);
        this.setState({assessment: res.data.assessment,submission_total:res.data.assessment.total});
        console.log('Ass check',this.state.assessment);
    }).catch(error => {
        // //console.log('error', error);
    });
}

  openModal=()=> {
    console.log('hitting');
    this.setState({modalIsOpen: true});
}

openRubricModal=()=> {
  console.log('hitting');
  this.setState({rubricModalIsOpen: true});
}


closeModal=()=>{
    this.setState({modalIsOpen: false});
}

toggle =()=> {
    this.setState({
        modalIsOpen: !this.state.modalIsOpen
    });
}

toggleRubric =()=> {
  this.setState({
      rubricModalIsOpen: !this.state.rubricModalIsOpen
  });
}

  handlePdfDownload=()=>{

    let selected_script = this.state.available_scripts[this.props.selectedRows.data[0].dataIndex];
    window.open("https://za.thinkdigitalacademy.org/api/marker-download-submission/"+selected_script.id);
  }

  handlePdfUpload=()=>{
    console.log('check here');
    this.setState({uploadDialog:true});
  }

  handleClick = () => {
    //console.log("click! current selected rows", this.props.selectedRows);
    
    let selected_scripts = this.props.available_scripts;
    let selectedRows = this.props.selectedRows.data;
    //console.log('selected scripts',selected_scripts);
    // //console.log('content type',selected_script.content_type);
    // //console.log('Selected script is',selected_script.id);
    selectedRows.forEach(function(obj){
      //console.log(obj.dataIndex);
      let script = selected_scripts[obj.dataIndex];
      window.open('/admin/mark_script/'+script.id+'/1', "_blank")
    });
    
  };

  handleDownload = () => {
    //console.log("click! current selected rows downloading", this.props.selectedRows);
    
    let selected_script = this.state.available_scripts[this.props.selectedRows.data[0].dataIndex];
    //console.log('content type',selected_script.content_type);
    //console.log('Selected script is',selected_script.id);
    window.open("https://za.thinkdigitalacademy.org/api/marker-download-submission/"+selected_script.id);
    // axios.get('https://portal.thinkdigitalcollege.co.za/api/marker-download-submission/'+selected_script.id).then(res=>{
    //       //console.log('subjects',res.data);   
    //      this.setState({subjectsLoading:false,subjects:res.data.subjects,subjectClicked:true,grade_name:res.data.grade_name,generateCards:false,goBackToSubjects:true});
    //   }).catch(error =>{
    //       //console.log('error',error);
    //   }); 
    // window.open('/admin/mark_script/'+selected_script.id+'/1', "_blank")
  };

  handlePlay = () => {
    //console.log("click! current selected rows playing", this.props.selectedRows);
    
    let selected_script = this.state.available_scripts[this.props.selectedRows.data[0].dataIndex];
    console.log('content type',selected_script);
    //console.log('Selected script is',selected_script.id);
    window.open('/admin/play_video/'+selected_script.id, "_blank")
  };

  handleChange(event){
    const target = event.target;
    const value =  target.value;
    const name = target.name;
    let cur = this.state;
    if(name=='submission_mark'){
        if(value>Number(cur.submission_total)){
            console.log('hit');
          toast('Total obtained can not be greater than the assessment total!!', {
              position: "top-right",
              autoClose: 5000,    
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: toast.TYPE.ERROR
          });
        }else{
          this.setState({
              [name]: value
            });
        }
    }else{
      this.setState({
          [name]: value
        });
    }
  }

  onFileChange = event => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] });
  
  };

  saveScript =()=>{
      // Create an object of formData
      const formData = new FormData();
      let selected_script = this.state.available_scripts[this.props.selectedRows.data[0].dataIndex];
      // Update the formData object
      formData.append(
        "script",this.state.selectedFile
      );
      formData.append(
        "submission_total",this.state.submission_total
      );
      formData.append(
        "submission_mark",this.state.submission_mark
      );
      formData.append(
        "submission_id",selected_script.id
      );
      formData.append('result_type', 'marker-uploaded');
      // Details of the uploaded file
      // console.log(this.state.selectedFile);
        let cur = this;
      // Request made to the backend api
      // Send formData object
      if( cur.state.submission_total>0){
        axios({
            headers: {
                'content-type': 'application/json'
            },
            method: 'post',
            url: 'https://admin.thinkdigitalacademy.org/api/marker-submit-marker-result',
            data: formData
        }).then(res => {
           
            toast(res.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: toast.TYPE.SUCCESS
          });
        }).catch(error => {
            let error_result = error.response;
            console.log('Error',error_result);
            toast(error_result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }else{
        toast("Please enter a valid total. Total mark can not be less than or equal to zero", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: toast.TYPE.ERROR
        });
    }
  }

  saveRubric =()=>{
    // Create an object of formData
    const formData = new FormData();
    let selected_script = this.state.available_scripts[this.props.selectedRows.data[0].dataIndex];
    // Update the formData object
    formData.append(
      "script",this.state.selectedFile
    );
    formData.append(
      "submission_total",this.state.submission_total
    );
    formData.append(
      "submission_mark",this.state.submission_mark
    );
    formData.append(
      "submission_id",selected_script.id
    );
    formData.append('result_type', 'marker-uploaded');
    // Details of the uploaded file
    // console.log(this.state.selectedFile);
      let cur = this;
    // Request made to the backend api
    // Send formData object
    if( cur.state.submission_total>0){
      axios({
          headers: {
              'content-type': 'application/json'
          },
          method: 'post',
          url: 'https://admin.thinkdigitalacademy.org/api/marker-submit-marker-result-rubric',
          data: formData
      }).then(res => {
         
          toast(res.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: toast.TYPE.SUCCESS
        });
      }).catch(error => {
          let error_result = error.response;
          console.log('Error',error_result);
          toast(error_result, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: toast.TYPE.ERROR
          });
      });
  }else{
      toast("Please enter a valid total. Total mark can not be less than or equal to zero", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: toast.TYPE.ERROR
      });
  }
}

  render() {
    const { classes } = this.props;

    return (
     <>
     
 {
        this.state.content_type ==="pdf" ?<div>
          <div className={"custom-toolbar-select"}>
        <Tooltip title={"Mark Script"}>
          <IconButton className={classes.iconButton} onClick={this.handleClick}>
            <DoneAllIcon className={classes.doneAllIcon} />
          </IconButton>
        </Tooltip>      
        <Tooltip title={"Upload Marked Script"}>
          <IconButton className={classes.iconButton} onClick={this.openModal}>
            <Upload className={classes.uploadIcon} />
          </IconButton>
        </Tooltip>
        <Tooltip title={"Download Script for marking"}>
          <IconButton className={classes.iconButton} onClick={this.handlePdfDownload}>
            <Download className={classes.doneAllIcon} />
          </IconButton>
        </Tooltip> 
        {
          ((this.state.assessment_name.toLowerCase().includes('igo')||this.state.assessment_name.toLowerCase().includes('egd')||this.state.assessment_name.toLowerCase().includes('visual')|| this.state.assessment_name.toLowerCase().includes('tourism') || this.state.assessment_name.toLowerCase().includes('visuele kuns') || this.state.assessment_name.toLowerCase().includes('toerisme')))&&<>
                <Tooltip title={"Upload Marked Rubric"}>
          <IconButton className={classes.iconButton} onClick={this.openRubricModal}>
            <RubricIcon className={classes.rubricIcon} />
          </IconButton>
        </Tooltip>
          </>
        }
      </div></div>:(this.state.content_type==="zip")?<div className={"custom-toolbar-select"}>
      <Tooltip title={"Upload Marked Rubric"}>
          <IconButton className={classes.iconButton} onClick={this.openRubricModal}>
            <RubricIcon className={classes.rubricIcon} />
          </IconButton>
        </Tooltip>
      <Tooltip title={"Upload Marked Folder"}>
          <IconButton className={classes.iconButton} onClick={this.openModal}>
            <Upload className={classes.uploadIcon} />
          </IconButton>
        </Tooltip>
        <Tooltip title={"Download Submission"}>
          <IconButton className={classes.iconButton} onClick={this.handleDownload}>
            <Download className={classes.doneAllIcon} />
          </IconButton>
        </Tooltip>      
      </div>:<><div className={"custom-toolbar-select"}>
      <Tooltip title={"Upload Marked Rubric"}>
          <IconButton className={classes.iconButton} onClick={this.openRubricModal}>
            <RubricIcon className={classes.rubricIcon} />
          </IconButton>
        </Tooltip>
        <Tooltip title={"Play Video"}>
          <IconButton className={classes.iconButton} onClick={this.handlePlay}>
            <VideoPlay className={classes.doneAllIcon} />
          </IconButton>
        </Tooltip>      
      </div></>
      }
     {
       <>
       <Modal className="modal-dialog-centered"
       isOpen={
           this.state.modalIsOpen
       }
       toggle={
           this.toggle
       }
       size='lg'>
       <div className="modal-header">
           <h5 className="modal-title" id="exampleModalLabel">
               Upload Marked Script/Folder
           </h5>
           <button aria-label="Close" className="close" data-dismiss="modal" type="button"
               onClick={
                   this.toggle
           }>
               <span aria-hidden={true}>×</span>
           </button>
       </div>
       <div className="modal-body">
           <Form>
           <Row>
              <Col lg="6">
                <Input value={this.state.student.name +' ' + this.state.student.surname} disabled onChange={
                                    this.handleChange
                                }/>
                </Col>
                <Col lg="6">
                <Input value={this.state.assessment.assessment_name} disabled onChange={
                                    this.handleChange
                                }/>
                </Col>
              </Row>
               <Row>
               <Col lg="6">
                       <FormGroup>
                           <label className="form-control-label" htmlFor="input-contact-number">
                               Total
                           </label>
                           <Input name="submission_total"
                               value={
                                   this.state.submission_total
                               }
                               
                               className="form-control-alternative"
                               id="input-submission-total"
                               placeholder="Submission Total"
                               type="number"
                               onChange={
                                   this.handleChange
                               }/>
                       </FormGroup>
                   </Col>
                   <Col lg="6">
                       <FormGroup>
                           <label className="form-control-label" htmlFor="input-first-name">
                               Mark Obtained
                           </label>
                           <Input name="submission_mark" className="form-control-alternative"
                               value={
                                this.state.submission_mark
                            }
                               id="input-submission-mark"
                               placeholder="Mark Obtained"
                               type="number"
                               onChange={
                                   this.handleChange
                               }/>
                       </FormGroup>
                   </Col>

               </Row>
               <Row> 
               <Col lg="6"> 
               <Input type="file" onChange={this.onFileChange} />
                </Col>
               </Row>
           </Form>

       </div>
       <div className="modal-footer">                               
           <Button onClick={this.saveScript} size="sm" color="success" type="button">
               Upload Script
           </Button>
       </div>
   </Modal>

<Modal className="modal-dialog-centered"
isOpen={
    this.state.rubricModalIsOpen
}
toggle={
    this.toggle
}
size='lg'>
<div className="modal-header">
    <h5 className="modal-title" id="exampleModalLabel">
        Upload Marked Rubric
    </h5>
    <button aria-label="Close" className="close" data-dismiss="modal" type="button"
        onClick={
            this.toggleRubric
    }>
        <span aria-hidden={true}>×</span>
    </button>
</div>
<div className="modal-body">
    <Form>
    <Row>
       <Col lg="6">
         <Input value={this.state.student.name +' ' + this.state.student.surname} disabled onChange={
                             this.handleChange
                         }/>
         </Col>
         <Col lg="6">
         <Input value={this.state.assessment.assessment_name} disabled onChange={
                             this.handleChange
                         }/>
         </Col>
       </Row>
        <Row>
        <Col lg="6">
                <FormGroup>
                    <label className="form-control-label" htmlFor="input-contact-number">
                        Total
                    </label>
                    <Input name="submission_total"
                        value={
                            this.state.submission_total
                        }
                        
                        className="form-control-alternative"
                        id="input-submission-total"
                        placeholder="Submission Total"
                        type="number"
                        onChange={
                            this.handleChange
                        }/>
                </FormGroup>
            </Col>
            <Col lg="6">
                <FormGroup>
                    <label className="form-control-label" htmlFor="input-first-name">
                        Mark Obtained
                    </label>
                    <Input name="submission_mark" className="form-control-alternative"
                        value={
                         this.state.submission_mark
                     }
                        id="input-submission-mark"
                        placeholder="Mark Obtained"
                        type="number"
                        onChange={
                            this.handleChange
                        }/>
                </FormGroup>
            </Col>

        </Row>
        <Row> 
        <Col lg="6"> 
        <Input type="file" onChange={this.onFileChange} />
         </Col>
        </Row>
    </Form>

</div>
<div className="modal-footer">                               
    <Button onClick={this.saveRubric} size="sm" color="success" type="button">
        Upload Rubric
    </Button>
</div>
</Modal></>
     }

     </>
      
    );
  }
}
export default connect(mapStateToProps)(withStyles(defaultToolbarSelectStyles)(CustomToolbarSelect));
